import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/shared/ui/alert-dialog';

interface DeleteTeamDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  teamName?: string;
  memberCount?: number;
  isDeleting?: boolean;
  onConfirm: () => void;
}

export function DeleteTeamDialog({
  open,
  onOpenChange,
  teamName,
  memberCount,
  isDeleting = false,
  onConfirm,
}: DeleteTeamDialogProps) {
  const memberNote =
    memberCount && memberCount > 0
      ? ` Its ${memberCount} member${memberCount === 1 ? '' : 's'} will be unassigned from the team and any shift assignments removed.`
      : ' Any shift assignments for this team will be removed.';

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Team</AlertDialogTitle>
          <AlertDialogDescription>
            {teamName ? `"${teamName}" will be deleted.` : 'This team will be deleted.'}
            {memberNote} This can be undone by an administrator.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isDeleting}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            {isDeleting ? 'Deleting…' : 'Delete Team'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
